import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API } from 'src/app/configs/api.config';
import { Subject } from 'rxjs';

@Injectable()
export class DeviceManagerService {

  contentChange = new Subject;
  currentDeviceId;

  constructor(
    private http: HttpClient,
  ) { }

  getDeviceList(page) {
    return this.http.get<ResponseModel>(API.DEVICE, {
      params: {
        page: page.pageNumber + 1,
        perPage: page.size
      }
    })
  }

  getDeviceInfo(deviceId = this.currentDeviceId) {
    return this.http.get<ResponseModel>(API.DEVICE + '/' + deviceId)
  }

  searchDevice(page, keyword) {
    return this.http.get<ResponseModel>(API.DEVICE + '/search', {
      params: {
        keyword: keyword,
        page: page.pageNumber + 1,
        perPage: page.size
      }
    })
  }

  getOnlineDeviceNum() {
    return this.http.get<ResponseModel>(API.DEVICE + '/online')
  }

  searchDeviceByUserId(page, userId) {
    return this.http.get<ResponseModel>(API.DEVICE + '/search', {
      params: {
        userId: userId,
        page: page.pageNumber + 1,
        perPage: page.size
      }
    })
  }

  searchDeviceByDeviceType(page, deviceType, version = "") {
    let searchParams
    if (version == "") {
      searchParams = {
        deviceType: deviceType,
        page: page.pageNumber + 1,
        perPage: page.size
      }
    } else {
      searchParams = {
        deviceType: deviceType,
        version: version,
        page: page.pageNumber + 1,
        perPage: page.size
      }
    }
    return this.http.get<ResponseModel>(API.DEVICE + '/search', {
      params: searchParams
    })
  }

  unbindDevice(deviceId, phone) {
    return this.http.post<ResponseModel>(API.DEVICE + "/unbind", {
      deviceId: deviceId,
      phone: phone
    })
  }

  deleteDevice(deviceId) {
    return this.http.post<ResponseModel>(API.DEVICE + "/delete", {
      deviceId: deviceId
    })
  }

  getDeviceLogs(deviceId, page, perPage, startDate: string, endDate: string) {
    let params = {
      deviceName: deviceId,
      page: page,
      perPage: perPage,
    }
    if (startDate != '') {
      params['startDate'] = startDate
    }
    if (endDate != '') {
      params['endDate'] = endDate
    }
    return this.http.get<ResponseModel>(API.DEVICE_LOG, {
      params: params
    })
  }

  getDeviceObject(deviceId) {
    return this.http.get<ResponseModel>(API.DEVICE_OBJECT, {
      params: { deviceId: deviceId }
    })
  }

  setDeviceObject(deviceId, data) {
    return this.http.post<ResponseModel>(API.DEVICE_OBJECT, {
      deviceId: deviceId,
      data: data
    })
  }

}
